<template>
  <div @touchmove.prevent class="model-mask" v-if="show">
    <div class="logistics-info">
      <div class="title">请填写寄回物流信息</div>
      <div class="form">
        <div class="epxpress-company">
          <em>快递公司</em>
          <vm-select filterable inputclass="fill-select" placeholder="请选择" v-model="expressName">
            <vm-option
              :key="index"
              :label="item"
              :value="item"
              v-for="(item, index) in expressList"
            ></vm-option>
          </vm-select>
        </div>
        <div class="express-number">
          <em>运单号</em>
          <input placeholder="请输入快递单号" type="text" v-model="expressNumber" />
        </div>
      </div>
      <div class="handler-btn">
        <button @click="cancelHandler" class="cancel">取消</button>
        <button @click="confrimHandler" class="confrim">确定</button>
      </div>
    </div>
  </div>
</template>

<script>
import { VmSelect, VmOption } from 'vue-multiple-select'
export default {
  name: 'fillInfo',
  components: {
    VmSelect,
    VmOption
  },
  props: {
    show: {
      type: Boolean
    },
    expressList: {
      type: Array
    }
  },
  data () {
    return {
      expressName: '',
      expressNumber: ''
    }
  },
  methods: {

    cancelHandler () {
      this.$emit('cancelHandler', false)
    },

    confrimHandler () {
      if (this.expressName === '') {
        this.$toast('请选择快递公司')
        return false
      }
      if (this.expressNumber === '') {
        this.$toast('请输入您的快递单号')
        return false
      }
      this.$emit('confrimHandler', {
        expressName: this.expressName,
        expressNumber: this.expressNumber
      })
    }
  }
}
</script>
<style>
.fill-select {
  width: 3.93rem !important;
  height: 0.74rem;
  border: 0.5px solid #979797;
  padding-left: 0.2rem;
}
.fill-select::-webkit-input-placeholder {
  color: #c0c4cc;
}
.epxpress-company /deep/ .vm-input__icon {
  color: #c0c4cc !important;
}
</style>
<style lang="less" scoped>
.model-mask {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  .flex-center;
  z-index: 999;
}
.logistics-info {
  width: 6.3rem;
  height: 5.3rem;
  background-color: #fff;
  border-radius: 0.14rem;
  font-size: 0.24rem;
  color: #404040;
  .title {
    margin-top: 0.28rem;
    margin-bottom: 0.6rem;
    padding-left: 0.34rem;
    margin-left: 0.13rem;
    border-left: 0.08rem solid #ff3232;
  }
  .form {
    margin-left: 0.47rem;
    em {
      width: 0.96rem;
      text-align: right;
      display: inline-block;
      margin-right: 0.25rem;
    }
    input {
      width: 3.93rem;
      height: 0.74rem;
      border: 0.5px solid #979797;
      box-sizing: border-box;
      padding-left: 0.2rem;
      border-radius: 4px;
    }
    input::-webkit-input-placeholder {
      color: #c0c4cc;
    }
    input:focus {
      border-color: #409eff;
    }
    .express-company {
    }
    .express-number {
      margin-top: 0.45rem;
    }
  }
  .handler-btn {
    width: 4.64rem;
    display: flex;
    justify-content: space-between;
    margin: 0.5rem auto 0;
    button {
      width: 2rem;
      height: 0.8rem;
      color: #fff;
      font-size: 0.32rem;
      border-radius: 0.08rem;
    }
    .cancel {
      color: #404040;
      background-color: #f0f0f0;
    }
    .confrim {
      background-color: #ff2851;
    }
  }
}
</style>
